const thumbSwiper = new Swiper('.thumb-slider', {
  direction: 'horizontal',
  spaceBetween: 2,
  slidesPerView: 3,
  navigation: {
    nextEl: '.thumb-button-next',
    prevEl: '.thumb-button-prev',
  },
  watchSlidesProgress: true,
  watchSlidesVisibility: true,
  breakpoints: {
    425: {
      direction: 'vertical',
      spaceBetween: 30,
    },
    320: {
      slidesPerView: 4,
    },
  },
});

const mainSwiper = new Swiper('.main-slider', {
  direction: 'horizontal',
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  navigation: {
    nextEl: '.main-button-next',
    prevEl: '.main-button-prev',
  },
  thumbs: {
    swiper: thumbSwiper,
  },
  zoom: {
    maxRatio: 5,
  },
});

const modalWindow = document.getElementById('slider-modal');
const modalCloseButton = document.getElementById('slider-modal__close-button');

const modal_thumb_slider_swiper = new Swiper('.slider-modal-thumb', {
  direction: 'horizontal',
  slidesPerView: 'auto',
  spaceBetween: 40,
  centeredSlides: true,
  navigation: {
    nextEl: '.slider-modal-thumb-next',
    prevEl: '.slider-modal-thumb-prev',
  },
});

const modal_slider_swiper = new Swiper('.slider-modal', {
  direction: 'horizontal',
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  navigation: {
    nextEl: '.slider-modal-next',
    prevEl: '.slider-modal-prev',
  },
  thumbs: {
    swiper: modal_thumb_slider_swiper,
  },
  zoom: {
    maxRatio: 5,
  },
});

const slideCount = mainSwiper.slides.length;

if (slideCount < 5) {
  mainSwiper.params.loop = false;
  mainSwiper.params.centeredSlides = false;
  mainSwiper.update();
}

mainSwiper.slides.forEach((slide) => {
  slide.onclick = () => {
    const isVideo = slide.querySelector('video') !== null;
    if (isVideo) return;

    modalWindow.style.display = 'flex';
    modal_slider_swiper.activeIndex = slide.dataset.swiperSlideIndex;
    modal_slider_swiper.slideTo(slide.dataset.swiperSlideIndex);
  };
});

modalCloseButton.addEventListener('click', (event) => {
  modalWindow.style.display = 'none';
});

const zoomFactor = 1.2;
const magnifierSize = 300;

modal_slider_swiper.slides.forEach((slide) => {
  const image = slide.querySelector('.zoomable');
  const magnifier = slide.querySelector('.magnifier');

  if (!magnifier) {
    console.error('Canvas not found for slide:', slide);
    return;
  }

  const ctx = magnifier.getContext('2d');

  magnifier.width = magnifierSize;
  magnifier.height = magnifierSize;

  const img = new Image();
  img.src = image.src;

  const isMobile = window.innerWidth <= 768;

  if (isMobile) {
    return;
  } else {
    image.addEventListener('mousemove', (e) => {
      const rect = image.getBoundingClientRect();

      const scaleX = img.width / rect.width;
      const scaleY = img.height / rect.height;

      const x = (e.clientX - rect.left) * scaleX;
      const y = (e.clientY - rect.top) * scaleY;

      const offset = 20;
      magnifier.style.left = `${e.clientX + offset}px`;
      magnifier.style.top = `${e.clientY - magnifierSize - offset}px`;
      magnifier.style.display = 'block';

      ctx.clearRect(0, 0, magnifierSize, magnifierSize);
      ctx.drawImage(
        img,
        x - magnifierSize / (2 * zoomFactor),
        y - magnifierSize / (2 * zoomFactor),
        magnifierSize / zoomFactor,
        magnifierSize / zoomFactor,
        0,
        0,
        magnifierSize,
        magnifierSize,
      );
    });

    image.addEventListener('mouseleave', () => {
      magnifier.style.display = 'none';
    });
  }
});
